module.exports = __webpack_public_path__ + "assets/img/j-bar.149aeacb.png";